import React from 'react';
import { ErrorMessage } from 'formik';
import PropTypes from 'prop-types';

//styles
import { FormGroup } from 'components/styled/Form.styled';

import ErrorField from '../ErrorField';
//components
import FormLabel from '../Label';

import TextAreaInput from './TextArea';

const TextAreaField = ({
  name,
  label,
  error,
  rows,
  disabled,
  isRequired,
  placeholder,
  readOnly = false,
  mb = '1.5rem',
  onInput,
  autoResize,
  margin,
}) => {
  return (
    <FormGroup mb={mb}>
      {label && (
        <FormLabel
          label={label}
          name={name}
          error={error}
          isRequired={isRequired}
          margin={margin}
        />
      )}
      <TextAreaInput
        rows={rows}
        name={name}
        error={error}
        disabled={disabled}
        placeholder={placeholder}
        readOnly={readOnly}
        margin="0 0 0.5rem 0"
        onInput={onInput}
        autoResize={autoResize}
      />
      <ErrorMessage name={name} component={ErrorField} />
    </FormGroup>
  );
};

TextAreaField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  error: PropTypes.bool,
  rows: PropTypes.number,
  disabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  placeholder: PropTypes.string,
  margin: PropTypes.string,
  onInput: PropTypes.func,
  autoResize: PropTypes.bool,
};

export default TextAreaField;
